enum AccountTypeEnum {
    IncomeTrust = 'INCOME_TRUST',
    Marketplace = 'MARKETPLACE',
    Private = 'PRIVATE',
}

export default AccountTypeEnum;
